<script lang="ts">
    import { IconMapSearch, IconMessageCircle2, IconSearch, IconSettings, IconUsers } from "@wa-icons";
    import LL from "../../../i18n/i18n-svelte";

    interface Props {
        searchOpen: boolean;
        peopleOpen: boolean;
        onSearch: () => void;
        onPeople: () => void;
        onChat: () => void;
        onMap: () => void;
        onSettings: () => void;
    }

    let { searchOpen, peopleOpen, onSearch, onPeople, onChat, onMap, onSettings }: Props = $props();
</script>

<aside
    data-testid="nutrivera-workspace-rail"
    class="pointer-events-auto fixed inset-y-0 start-0 z-[305] flex w-12 flex-col items-center border-e border-solid border-[var(--nutrivera-shell-border)] bg-[var(--nutrivera-shell-bg)] py-2 text-[var(--nutrivera-shell-muted)]"
>
    <button
        type="button"
        data-testid="workspace-search"
        aria-label={$LL.chat.search()}
        aria-pressed={searchOpen}
        class="nutrivera-rail-button"
        onclick={onSearch}
    >
        <IconSearch />
    </button>
    <button
        type="button"
        data-testid="workspace-map"
        aria-label={$LL.actionbar.map()}
        class="nutrivera-rail-button"
        onclick={onMap}
    >
        <IconMapSearch />
    </button>
    <button
        type="button"
        data-testid="workspace-chat"
        aria-label={$LL.actionbar.help.chat.title()}
        class="nutrivera-rail-button"
        onclick={onChat}
    >
        <IconMessageCircle2 />
    </button>
    <button
        type="button"
        data-testid="workspace-people"
        aria-label={$LL.actionbar.help.users.title()}
        aria-pressed={peopleOpen}
        class="nutrivera-rail-button"
        onclick={onPeople}
    >
        <IconUsers />
    </button>
    <div class="flex-1"></div>
    <button
        type="button"
        data-testid="workspace-settings"
        aria-label={$LL.menu.sub.settings()}
        class="nutrivera-rail-button"
        onclick={onSettings}
    >
        <IconSettings />
    </button>
</aside>

<style>
    .nutrivera-rail-button {
        width: 40px;
        height: 40px;
        margin: 2px 0;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        color: inherit;
    }

    .nutrivera-rail-button:hover,
    .nutrivera-rail-button[aria-pressed="true"] {
        color: var(--nutrivera-shell-text);
        background: var(--nutrivera-shell-hover);
    }

    .nutrivera-rail-button:focus-visible {
        outline: 2px solid var(--nutrivera-shell-accent);
        outline-offset: 2px;
    }
</style>
